module.exports = __webpack_public_path__ + "img/maker_processing.58ec18c7.jpg";